export default {
  inserted: el => {
    let loadImage = null
    el.style.visibility='hidden'
    if (el.nodeName === 'IMG') {
      loadImage = function loadImage() {
        const imageElement = el

        const srcUrl = imageElement.dataset.src
        if (!srcUrl) {
          throw new Error('data-src must have value', imageElement)
        }

        imageElement.src = parseToThumbnailUrl(srcUrl)
        imageElement.addEventListener("error", () => console.warn('failed to load ' + srcUrl))
        imageElement.style.visibility = 'visible'
      }
    } else {
      loadImage = function loadImage() {
        const element = el

        const srcUrl = element.dataset.backgroundUrl
        if (!srcUrl) {
          throw new Error('data-background-url must have value', element)
        }
      
        element.style.backgroundImage = 'url(' + parseToThumbnailUrl(srcUrl) + ')'
        element.style.visibility = 'visible'
      }
    }

    function parseToThumbnailUrl(srcUrl) {
      const matchesImgur = srcUrl.match(/https:\/\/i.imgur.com\/(\w{7}).(jpg|jpeg)/) // only lazy image for jpg/jpeg format
      let newSrcUrl = srcUrl

      if (matchesImgur) {
        const size = 2880 // Fix the size
        newSrcUrl = srcUrl.replace(matchesImgur[1], matchesImgur[1] + '_d')
        newSrcUrl += '?maxwidth=' + size
      }
      return newSrcUrl
    }

    function handleIntersect(entries, observer) {
      entries.forEach(entry => {
        if (!entry.isIntersecting) {
          return;
        } else {
          loadImage()
          observer.unobserve(el)
        }
      })
    }

    function createObserver() {
      const options = {
        root: null,
        threshold: "0",
      };

      const observer = new IntersectionObserver(handleIntersect, options)

      observer.observe(el)
    }

    if (!window["IntersectionObserver"]) {
      loadImage()
    } else {
      createObserver()
    }
  }
};